import { IPageTabNavLink } from "../interfaces-and-types";

export const accountdetailsLink: IPageTabNavLink[] = [
    {
        name: 'Account Settings',
        route: '',
    },
]